const API_BASE_URL = 'https://kds-api.softcom.services';
//const API_BASE_URL = 'http://127.0.0.1:8000';
//const NAMESPACE =  'rubpc-teste'

const fetchOrdersFromApi = async (namespace, setores = [], forceSync = false) => {
  try {
    const params = new URLSearchParams();
    params.set('force_sync', forceSync);

    if (setores.length > 0) {
      setores.forEach(s => params.append('setor', s));
    }

    const url = `${API_BASE_URL}/mesas/${namespace}?${params.toString()}`;

    const response = await fetch(url, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    const result = await response.json();
    //console.log(result)
    return {
      success: true,
      data: result || [],
    };
  } catch (error) {
    console.error('❌ Erro ao buscar pedidos:', error);
    return {
      success: false,
      data: [],
    };
  }
};

const patchMesaItemFromApi = async (namespace, status, mesa_id, guid_item) => {
  try {
    const body = JSON.stringify({ status, mesa_id, guid_item })
    console.log(body)
    const response = await fetch(`${API_BASE_URL}/mesas/item/${namespace}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: body,
    });

    if (!response.ok) {
      console.error('HTTP status:', response.status);
      return { success: false };
    }
    const data = await response.json();
    // console.log('Resposta:', data);
    return { success: true, data };
  } catch (error) {
    console.error('❌ Erro ao atualizar item:', error);
    return { success: false };
  }
};

const patchMesaItemsFromApi = async (namespace, mesa_id, mesa_seq, status) => {
  try {
    const body = JSON.stringify({ mesa_id, mesa_seq, status })
    console.log(body)
    const response = await fetch(
      `${API_BASE_URL}/mesas/items/${namespace}`,
      {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        body: body,
      }
    );

    if (!response.ok) return { success: false };
    const data = await response.json();
    // console.log('Resposta itens:', data);
    return { success: true, data };
  } catch (error) {
    console.error('❌ Erro ao atualizar itens:', error);
    return { success: false };
  }
};

const validateNamespaceFromApi = async (namespace) => {
  try {
    const response = await fetch(`${API_BASE_URL}/token/${namespace}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    // Status 200: Namespace existe e está funcionando
    if (response.status === 200) {
      const data = await response.json();
      // console.log('Resposta:', data);
      return { success: true, data };
    }

    // Status 502: Namespace existe mas serviço indisponível (tratar como sucesso)
    if (response.status === 502) {
      console.warn('⚠️ Namespace existe mas serviço indisponível (502)');
      return { success: true, data: { status: 502, message: 'Namespace válido' } };
    }

    // Status 404 ou outros: Namespace não existe
    console.error('HTTP status:', response.status);
    return { success: false };

  } catch (error) {
    console.error('❌ Erro ao validar namespace:', error);
    return { success: false };
  }
};

const fetchSetoresFromApi = async (namespace) => {
  try {
    const response = await fetch(`${API_BASE_URL}/setores/${namespace}`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    });

    if (!response.ok) {
      console.error('HTTP status:', response.status);
      return { success: false, data: [] };
    }

    const result = await response.json();
    return {
      success: true,
      data: result?.setores || [],
      total: result?.total || 0,
    };
  } catch (error) {
    console.error('❌ Erro ao buscar setores:', error);
    return { success: false, data: [], total: 0 };
  }
};

// Função para extrair namespace da URL
const getNamespaceFromUrl = () => {
  const path = window.location.pathname;
  // Remove a barra inicial se existir e pega o primeiro segmento
  const segments = path.replace(/^\//, '').split('/');
  return segments[0] || 'default'; // 'default' como fallback
};

// Função para verificar se está na página raiz
const isRootPage = () => {
  const path = window.location.pathname;
  return path === '/' || path === '';
};

export { fetchOrdersFromApi, patchMesaItemFromApi, patchMesaItemsFromApi, validateNamespaceFromApi, getNamespaceFromUrl, isRootPage, fetchSetoresFromApi };